import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { cloneRecipe } from "@/lib/api";

export default function CloneRecipeDialog({ recipe, onCloned }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open) setName(`Cópia de ${recipe.name}`);
  }, [open, recipe.name]);

  async function onConfirm() {
    setBusy(true);
    try {
      const r = await cloneRecipe(recipe.id, (name || "").trim());
      toast.success(`Rotina clonada: "${r.name}"`);
      setOpen(false);
      onCloned?.(r);
    } catch (e) {
      toast.error(`Falhou: ${e?.response?.data?.detail || e.message}`);
    } finally {
      setBusy(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline" data-testid="recipe-card-clone-button" title="Clonar esta rotina">
          <Copy className="h-3.5 w-3.5 mr-1"/> Clonar
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Clonar rotina</DialogTitle>
          <DialogDescription>
            Cria uma cópia idêntica de <span className="font-medium">{recipe.name}</span>. O agendamento <em>não</em> é copiado — terás de o reactivar manualmente se for preciso.
          </DialogDescription>
        </DialogHeader>
        <div>
          <Label htmlFor="clone-name" className="text-xs">Nome da nova rotina</Label>
          <Input
            id="clone-name"
            data-testid="clone-recipe-name-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
            onFocus={(e) => e.target.select()}
            onKeyDown={(e) => { if (e.key === "Enter" && !busy) onConfirm(); }}
            placeholder={`Cópia de ${recipe.name}`}
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setOpen(false)} disabled={busy}>Cancelar</Button>
          <Button onClick={onConfirm} disabled={busy} data-testid="clone-recipe-confirm-button">
            {busy ? "A clonar…" : "Clonar"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
